<template>
  <v-content class="full-height">
    <v-container
      fluid
      grid-list-md
      id="tomadores-editar"
      class="full-height proposta__container"
    >
      <v-flex xs12>
        <form-alert
          :type="alertText.type"
          :message="alertText.message"
          @close="closeFormAlert"
        ></form-alert>
      </v-flex>

      <v-flex xs12 mb-3>
        <a @click="$router.push({ path: '/tomadores' })">
          <span class="font-weight-black subheading">
            <v-icon color="black">arrow_back</v-icon>Voltar
          </span>
        </a>
      </v-flex>

      <v-layout row wrap>
        <v-flex xs12>
          <label class="font-weight-black caption"
            >Escolha o tipo de tomador</label
          >
        </v-flex>

        <v-btn
          v-for="(text, index) in [
            'Empresa com CNPJ',
            'SPE / Consórcio',
            'Empresa Estrangeira sem CNPJ',
          ]"
          :disabled="text != 'Empresa com CNPJ'"
          :key="index"
          :class="{ active: taker.stepType == index + 1 }"
          :value="index + 1"
          @click="selectTakerType($event)"
          class="jns-button blue-button flex mb-4"
        >
          {{ text }}
          <v-icon v-if="taker.stepType == index + 1" class
            >check_circle_alt</v-icon
          >
        </v-btn>

        <!-- Empresa com CNPJ -->
        <div class="flex xs12" v-if="taker.stepType == 1">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :placeholder="'Pesquisar'"
                :label="'Digite o CNPJ'"
                :rules="[rules.obrigatorio, rules.cnpjInvalido]"
                append-icon="search"
                @input="unselectTaker"
                @click:append="getTakerByCNPJ"
                @keyup.enter="getTakerByCNPJ()"
                v-model="taker.cnpj"
                v-mask="'##.###.###/####-##'"
                class="jns-input"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 class="no-padding-bottom" v-if="taker.info">
              <div class="pull-right bold p-rel mt-30neg">
                <span
                  class="info-red"
                  v-if="taker.info.status_nomeado == 'SEM_NOMEACAO'"
                >
                  Tomador liberado ao mercado
                  <v-tooltip slot="append" bottom>
                    <v-icon
                      slot="activator"
                      color="primary"
                      dark
                      class="custom-i"
                      >info</v-icon
                    >
                    <span>
                      <p class="info-red">Tomador liberado</p>
                      <p>
                        Para bloqueá-lo solicite uma emissão, formalize o
                        contrato de contragarantias ou anexe uma carta de
                        nomeação.
                      </p>
                    </span>
                  </v-tooltip>
                </span>
              </div>

              <!-- Retorno Pesquisa de tomador -->
              <person-info-box
                :info="taker.info"
                :show-unselect-button="false"
                :class="
                  taker.stepType == 1 &&
                  taker.info &&
                  taker.info.status_nomeado == 'SEM_NOMEACAO'
                    ? ''
                    : 'mt-0'
                "
              ></person-info-box>
              <!-- ./Retorno Pesquisa de tomador -->

              <!-- Carta de nomeação -->
              <div v-if="taker.info.status_nomeado != 'CORRETOR_NOMEADO'">
                <tomador-carta-nomeacao
                  :idTomador="taker.info.id"
                  :statusNomeado="taker.info.status_nomeado"
                  @complete="completeCartaNomeacao"
                ></tomador-carta-nomeacao>
              </div>
              <!-- ./Carta de nomeação -->
            </v-flex>
            <!-- ./Titulo e Retorno Pesquisa de tomador -->

            <!-- Titulo e Retorno Calculando Limites -->
            <v-flex
              xs6
              class="no-padding-bottom"
              v-if="taker.info && taker.info.status_nomeado != 'OUTRO_NOMEADO'"
            >
              <h2>Limites e taxas do tomador</h2>
              <limites-taxas
                :carregando="buscandoLimite"
                :erroBuscaLimite="erroBuscaLimite"
                :msgErroBuscaLimite="msgErroBuscaLimite"
                :taker="taker"
                :step="step"
                :tipo_pessoa="this.tipo_pessoa"
              ></limites-taxas>
            </v-flex>
          </v-layout>
        </div>

        <!-- SPE / Consórcio -->
        <div class="flex xs12" v-if="taker.stepType == 2">
          <v-layout
            row
            wrap
            v-if="
              !taker.hasOwnProperty('notFound') ||
              lastTakerSearchWasCNPJ ||
              (takerResults.length && showSelectTaker)
            "
          >
            <v-flex xs6>
              <v-text-field
                label="Digite o CNPJ ou a Razão Social"
                class="jns-input"
                placeholder=" "
                v-model="taker.name"
                append-icon="search"
                key="Razao Social"
                @click:append="getTakerByRazaoSocial"
                @keyup.enter="getTakerByRazaoSocial()"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <proposta-form
            v-if="taker.notFound"
            :person="taker"
            :type="'taker'"
            @click:append="getTakerByRazaoSocial()"
            @keyup.enter="getTakerByRazaoSocial()"
            v-on:updatePerson="updateTaker"
            v-on:formValid="updateTakerFormValid"
          ></proposta-form>

          <v-layout row wrap v-if="taker.notFound">
            <v-flex xs4>
              <v-btn
                class="jns-button yellow-button"
                @click.prevent="postTaker({ type: 'CONSORCIO' })"
                :disabled="!takerFormValid"
                >Salvar</v-btn
              >
            </v-flex>
          </v-layout>

          <v-flex xs6 v-if="taker.info">
            <person-info-box
              :info="taker.info"
              :show-unselect-button="!taker.wasPosted"
              v-on:unselect="unselectTaker"
            ></person-info-box>
          </v-flex>

          <v-layout
            row
            wrap
            v-if="taker.info && taker.info.status_nomeado != 'CORRETOR_NOMEADO'"
          >
            <tomador-carta-nomeacao
              :idTomador="taker.info.id"
              :statusNomeado="taker.info.status_nomeado"
              @complete="completeCartaNomeacao"
            ></tomador-carta-nomeacao>
          </v-layout>

          <div v-if="takerResults.length && showSelectTaker">
            <selecionar-empresa-list
              :results="takerResults"
              @click="selectTaker"
            />
          </div>

          <v-layout row wrap v-if="taker.showFormEconomicGroup">
            <composicao-consorcio-form
              v-on:addParticipant="participanteModal = true"
              :participants="takerParticipants"
              :hasParticipants="taker.hasParticipants"
              v-on:updatePercentageValues="checkIfDisabled(1, stepCompleted)"
              v-on:participantDelete="askForDeleteParticipant"
            />
          </v-layout>
        </div>

        <!-- Empresa Estrangeira sem CNPJ -->
        <div class="flex xs12" v-if="taker.stepType == 3">
          <v-layout
            row
            wrap
            v-if="
              !taker.hasOwnProperty('notFound') ||
              (takerResults.length && showSelectTaker)
            "
          >
            <v-flex xs6>
              <v-text-field
                class="jns-input"
                label="Digite a Razão Social"
                placeholder=" "
                v-model="taker.name"
                key="Empresa Estrangeira"
                append-icon="search"
                @click:append="getTakerByRazaoSocial({ foreign: true })"
                @keyup.enter="getTakerByRazaoSocial({ foreign: true })"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <proposta-form
            v-if="taker.notFound"
            :person="taker"
            :type="'taker'"
            :show-cademp="true"
            @click:append="getTakerByRazaoSocial()"
            @keyup.enter="getTakerByRazaoSocial()"
            v-on:updatePerson="updateTaker"
            v-on:formValid="updateTakerFormValid"
          ></proposta-form>

          <v-layout row wrap v-if="taker.notFound">
            <v-flex xs4>
              <v-btn
                class="jns-button yellow-button"
                @click.prevent="postTaker({ type: 'PJ_ESTRANGEIRO' })"
                :disabled="!takerFormValid"
                >Salvar</v-btn
              >
            </v-flex>
          </v-layout>

          <v-flex xs6 v-if="taker.info">
            <person-info-box
              :info="taker.info"
              :show-unselect-button="!taker.wasPosted"
              v-on:unselect="unselectTaker"
            />
          </v-flex>

          <v-layout
            row
            wrap
            v-if="taker.info && taker.info.status_nomeado != 'CORRETOR_NOMEADO'"
          >
            <tomador-carta-nomeacao
              :idTomador="taker.info.id"
              :statusNomeado="taker.info.status_nomeado"
              @complete="completeCartaNomeacao"
            ></tomador-carta-nomeacao>
          </v-layout>

          <div v-if="takerResults.length && showSelectTaker">
            <selecionar-empresa-list
              :results="takerResults"
              @click="selectTaker"
            ></selecionar-empresa-list>
          </div>
        </div>
      </v-layout>
    </v-container>

    <v-footer class="proposta__footer">
      <v-spacer></v-spacer>

      <v-btn
        class="jns-button width-auto yellow-button"
        @click="save()"
        :disabled="checkIfDisabled(1, stepCompleted)"
        v-if="taker.stepType == 2"
      >
        Salvar Cadastro
        <v-icon>arrow_right_alt</v-icon>
      </v-btn>
    </v-footer>

    <v-dialog v-model="confirmParticipantDelete" :max-width="'640'">
      <base-modal>
        <h2 class="title pb-5">
          Certeza que deseja deletar esse participante?
        </h2>
        <v-layout row wrap>
          <v-flex xs4></v-flex>
          <v-flex xs4>
            <button
              class="button jns-button yellow-button"
              @click="
                takerParticipants.splice(participantToBeDeleted, 1);
                participantToBeDeleted = false;
                confirmParticipantDelete = false;
              "
            >
              OK
            </button>
          </v-flex>
          <v-flex xs4>
            <button
              class="button jns-button white-button"
              @click="
                participantToBeDeleted = false;
                confirmParticipantDelete = false;
              "
            >
              Cancelar
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <v-dialog
      v-model="participanteModal"
      max-width="'640'"
      v-if="reloadParticipanteModal"
    >
      <adicionar-participante-modal
        @close="participanteModal = false"
        @addParticipant="addNewParticipant"
      />
    </v-dialog>

    <v-dialog v-model="loadingWaitingModal" persistent :max-width="'420'">
      <base-modal>
        <img
          :src="require('../../../assets/animations/loading-yellow.gif')"
          class="loading-animation"
          alt
        />
        <h2 class="title text-xs-center">Aguarde</h2>
        <p class="description text-xs-center mt-3">
          Estamos buscando os limites e taxas de crédito do Tomador, o processo
          pode demorar um pouco.
        </p>
      </base-modal>
    </v-dialog>
  </v-content>
</template>

<script lang="js">
import { isValidCnpj, isCNPJ, capitalize } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";
export default {
  name: "TomadoresCadastrar",
  mixins: [ViewMixin],
  data() {
    return {
      urlccg: "",
      assinarCcg: false,
      participantToBeDeleted: false,
      confirmParticipantDelete: false,
      participanteModal: false,
      step: 1,
      loadingFromBackendModal: false,
      cnpjErrorModal: false,
      confirmQuitModal: false,
      cnpjError: {
        title: "",
        message: "",
      },
      stepCompleted: 0,
      showSelectTaker: false,
      completedTaker: false,
      taker: {
        // cnpj: '21202303000167',
        // cnpj: '14444367000109',
        stepType: 1,
      },
      takerFormValid: false,
      takerParticipants: [],
      lastTakerSearchWasCNPJ: false,
      takerResults: [],
      foreignTaker: {},
      reloadParticipanteModal: true,
      tomadorSucessoAlertMessage: "Cadastro salvo com sucesso!",
      loadingWaitingModal: false,
      erroBuscaLimite: false,
      rules: {
        obrigatorio: (value) => !!value || "Campo obrigatório.",
        cnpjInvalido: (v) =>
          (!!v && isValidCnpj(v)) || "CNPJ inválido",
      },
    };
  },
  methods: {
    selectTakerType(event) {
      let t = this;
      let value = event.currentTarget.value;
      t.taker = { stepType: value };
      t.stepCompleted = 0;
      t.takerParticipants = [];
      t.takerResults = [];
      t.showSelectTaker = false;

      t.$forceUpdate();
    },

    askForDeleteParticipant(index) {
      let t = this;
      t.participantToBeDeleted = index;
      t.confirmParticipantDelete = true;
    },

    updateTaker(taker) {
      let t = this;
      t.taker = Object.assign(t.taker, taker);
    },

    checkIfDisabled(step, stepCompleted) {
      let t = this;
      if (+step == 1 && t.taker.stepType == 2) {
        let participantsComission = 0;
        if (!t.takerParticipants.length) return true;

        participantsComission = t.takerParticipants
          .map((item) => +item.porcentagem)
          .reduce((acc, cur) => acc + cur);

        return participantsComission != 100;
      }

      return !!stepCompleted;
    },

    updateTakerFormValid(formValid) {
      let t = this;
      t.takerFormValid = formValid;
    },

    defineUrlCcg(cnpj) {
      this.urlccg = `/tomadores/${cnpj}/contra-garantia`;
    },

    goToCcg() {
      this.$router.push({
        path: this.urlccg,
      });
    },

    async getTakerByCNPJ() {
      let t = this;
      this.erroBuscaLimite = false
      if (!t.taker.cnpj || !isValidCnpj(t.taker.cnpj)) return;
      let data;
      let cnpj = t.taker.cnpj.replace(/[^\w\s]/gi, "");

      this.showModalWaiting();
      t.unselectTaker();

      try {
        data = await t.$store.dispatch("GET_TAKER_DATA", { cnpj });
      } catch (e) {
        if (e && e[0] && !e[0].ativo) {
          return t.handleInactivePersonError(e[0], "Tomador");
        }
        this.defaultHandlerError(e);
        this.hideModalWaiting();
        return;
      }
      if (!data) {
        this.hideModalWaiting();
        return;
      }

      if (!data[0].situacao_ativo) {
        this.hideModalWaiting();
        this.modalTomadorInativo();
        t.stepCompleted = 0;
        return;
      }

      if (!data[0].sublimites.length) {
        this.erroBuscaLimite = true;

        if (data[0].status_nomeado == "OUTRO_NOMEADO")
          this.msgErroBuscaLimite = "Tomador possuí outro corretor nomeado.";
        else
          this.msgErroBuscaLimite =
            "Não é possível obter os limites do tomador.";
      }

      t.taker.info = data[0];


      // prevenir se necessario, toda vez que alguma pesquisa acontecer
      if (data[0].status_nomeado == "OUTRO_NOMEADO") t.stepCompleted = 0;

      if (data[0].status_nomeado != "OUTRO_NOMEADO") {
        this.assinarCcg = true;
        this.defineUrlCcg(cnpj);
        this.stepCompleted = 1;
      } else {
        this.assinarCcg = false;
      }

      this.hideModalWaiting();

      let alertMessage = this.getTakerAlertMessage(data[0]);
      this.alertText = this.handleAlertText2(alertMessage);

      await t.$nextTick();
      t.$forceUpdate();
    },

    showModalWaiting() {
      this.loadingWaitingModal = true;
    },

    hideModalWaiting() {
      this.loadingWaitingModal = false;
    },

    getTakerAlertMessage(taker) {
      if (taker.status_nomeado == "OUTRO_NOMEADO") {
        return "Tomador já possui corretor nomeado, favor inserir a Carta de Nomeação.";
      }
      return "Cadastro salvo com sucesso!";
    },

    modalTomadorInativo() {
      let options = {
        code: null,
        details: null,
        message:
          "Desculpe, este tomador não é compatível com a política da JNS Seguradora.",
        title: "Problema ao recuperar os dados tomador.",
      };
      this.setErrorModal(options);
    },

    async getTakerByRazaoSocial(options = {}) {
      let t = this;
      if (!t.taker.name) return;

      let data;
      let name = t.taker.name;
      let personType = options.foreign ? "PJ_ESTRANGEIRO" : "CONSORCIO";

      try {
        this.showLoadingAskWait();
        data = await t.$store.dispatch("GET_TAKER_DATA_RAZAOSOCIAL", {
          name,
          personType,
        });
      } catch (e) {
        let type = "taker";
        this.set404ErrorMessage(e, type);
        this.defaultHandlerError(e);
        this.showSelectTaker = false;
        if (!isCNPJ(name)) {
          this.taker.enderecos = [{}];
          this.taker.notFound = true;
          this.lastTakerSearchWasCNPJ = false;
        } else {
          this.taker.notFound = false;
          this.lastTakerSearchWasCNPJ = true;
        }
        await this.$nextTick();
      } finally {
        this.hideLoadingAskWait();
      }

      await this.$forceUpdate();
      await this.$nextTick();
      if (!data.length) return;

      await this.$nextTick();
      // this.taker.showFormEconomicGroup = true
      // this.taker.info = data[0]
      this.takerResults = data;

      // se o resultado não for através de uma busca por CNPJ
      // exibe a listagem de takers
      // mas se for, seleciona o primeiro resultado direto
      if (!isCNPJ(name)) {
        this.showSelectTaker = true;
        this.taker.notFound = false;
      } else {
        this.selectTaker(data[0]);
      }
      this.$forceUpdate();
    },

    selectTaker(taker) {
      let t = this;
      if (!taker.ativo) return;
      t.$set(t.taker, "info", taker);
      t.showSelectTaker = false;

      t.stepCompleted = 1;
      if (t.taker.status_nomeado == "OUTRO_NOMEADO") {
        t.stepCompleted = 0;
      }

      t.taker.showFormEconomicGroup = true;
      if (t.taker.info.participantes_consorcio.length) {
        t.taker.hasParticipants = true;
        t.takerParticipants = t.taker.info.participantes_consorcio;
      }
      t.$forceUpdate();
    },

    unselectTaker() {
      let t = this;
      t.$set(t.taker, "info", false);
      t.showSelectTaker = true;
      t.stepCompleted = 0;
      t.taker.showFormEconomicGroup = false;
      t.taker.hasParticipants = false;
      t.takerParticipants = [];
      t.assinarCcg = false;
      t.$forceUpdate();
    },

    preparePerson(person) {
      person.nome = person.name;
      person.endereco = person.enderecos[0];
      person.endereco.logradouro = [
        person.endereco.rua,
        person.endereco.numero,
        person.endereco.complemento,
      ].join(", ");

      delete person.notFound;
      delete person.enderecos;
      delete person.stepType;
      delete person.name;
      delete person.endereco.rua;
      delete person.endereco.numero;
      delete person.endereco.complemento;
      return person;
    },

    async save() {
      let alertMessage = {};
      if (this.takerParticipants) {
        try {
          await this.postConsorcio();
          alertMessage = {
            type: "success",
            message: "Tomador cadastrado com sucesso!",
          };
        } catch (e) {
          alertMessage = {
            type: "error",
            message: "Houve um erro ao processar a requisição",
          };
        }
      }
      this.alertText = this.handleAlertText2(
        alertMessage.type,
        alertMessage.message
      );
    },

    participantAdapter(participant) {
      let res = {
        id_participante: participant.id,
        porcentagem: +participant.porcentagem,
      };
      return res;
    },

    async postConsorcio() {
      this.showLoadingAskWait();
      let payload = {
        id_tomador: this.taker.info.id,
        participantes_consorcio: this.takerParticipants.map(
          this.participantAdapter
        ),
      };
      try {
        await this.$store.dispatch("INSERT_CONSORCIO", payload);
      } catch (e) {
        console.warn(e);
        return;
      } finally {
        this.hideLoadingAskWait();
      }
    },

    async postTaker(options) {
      let t = this;

      let taker = Object.assign({}, t.taker);
      taker = t.preparePerson(taker);
      taker.tipo_pessoa = options.type;

      let data;

      try {
        this.showLoadingAskWait();
        data = await t.$store.dispatch("INSERT_TAKER", taker);
      } catch (e) {
        console.warn(e);

        this.defaultHandlerError(e);
      }

      if (!data) return;
      t.taker.wasPosted = true;
      this.hideLoadingAskWait();
      t.stepCompleted = 1;
      t.taker.info = data;
      if (options.type == "CONSORCIO") {
        t.taker.showFormEconomicGroup = true;
      }
      await t.$nextTick();
      t.taker.notFound = false;

      t.$forceUpdate();
    },

    handleOutroNomeadoCartaUpload() {
      let t = this;
      let options = {
        title: `Documento enviado com sucesso!`,
        message: `Aguarde a notificação da avaliação da Carta de Nomeação, para seguir com o cadastro.`,
      };

      this.setErrorModal(options);
    },

    set404ErrorMessage(e, type) {
      let person =
        type == "taker" ? "tomador" : type == "insured" ? "segurado" : false;

      let errorMessage = {
        title: `${capitalize(person)} não encontrado`,
        message: `Não foi encontrado nenhum ${person}`,
      };

      if (e.status == 404) {
        e.data = errorMessage;
      }
      return;
    },

    addNewParticipant(participant) {
      let t = this;
      t.participanteModal = false;
      if (!participant.info) {
        participant.info = [];
      }

      t.$set(participant, "porcentagem", t.takerParticipants.length ? 0 : 100);

      t.takerParticipants.push(participant);
      t.reloadParticipanteModal = false;

      t.$nextTick(() => {
        t.reloadParticipanteModal = true;
        t.$forceUpdate();
      });
      t.$forceUpdate();
    },

    completeCartaNomeacao() {
      if (this.taker.info.status_nomeado == "SEM_NOMEACAO") {
        this.taker.info.status_nomeado = "CORRETOR_NOMEADO";
        this.$forceUpdate();
      } else handleOutroNomeadoCartaUpload();
    },
  },
};
</script>

<style lang="scss" scoped>
#jns .proposta__container {
  height: calc(100% - 77px);
  background-color: white;
}

.proposta__title {
  color: #282498;
  font-size: 18px;
}
.proposta__footer {
  padding-left: 24px !important;
  padding-right: 24px !important;
  padding-top: 30px;
  padding-bottom: 30px;
}
.proposta__blue-text {
  color: #282498;
  font-weight: bold;
  text-decoration: none;
  i {
    color: #282498;
    text-decoration: none;
    margin-right: 8px;
  }
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
.jns-button {
  text-transform: none;
  margin: 6px 12px;
}

.info-red {
  color: #d21a5e;

  .custom-i {
    color: #d21a5e !important;
    font-size: 18px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Tomadores/Cadastrar.vue